<template>
  <div
    ref="wrapper"
    style="height: var(--bottom-bar-height)"
    class="tw:absolute tw:bottom-0 tw:left-0 tw:px-2.5 tw:py-1.5 tw:w-full tw:bg-white/80 tw:z-1 tw:flexrow-2 tw:justify-between tw:items-center"
  >
    <div
      v-if="basemapDescription"
      @mouseenter="onHover"
      @mouseleave="onLeave"
      class="tw:shrink tw:min-w-4 tw:flex tw:relative tw:text-xxs tw:z-1"
    >
      <basemap-attribution-text ref="attribution" :description="basemapDescription" class="tw:truncate" />
      <div v-if="isAttributionGhostVisible" class="attribute-wrapper tw:absolute tw:z-2">
        <basemap-attribution-text :description="basemapDescription" />
      </div>
    </div>
    <div class="tw:ml-auto">
      <the-navbar-tools-panel-map-info />
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify';

import BasemapAttributionText from '@/components/BasemapAttributionText';
import TheNavbarToolsPanelMapInfo from '@/components/TheNavbarToolsPanelMapInfo';

export default {
  name: 'MapInfoBar',
  components: {
    BasemapAttributionText,
    TheNavbarToolsPanelMapInfo,
  },
  props: {
    basemap: {
      type: [Number, null],
    },
  },
  data: () => ({
    isAttributionGhostVisible: false,
  }),
  computed: {
    basemapDescription: get('layers/basemapLayers@:basemap.description'),
  },
  methods: {
    onHover() {
      if (this.$refs.attribution.$el.clientWidth >= this.$refs.attribution.$el.scrollWidth) return;
      this.isAttributionGhostVisible = true;
    },
    onLeave() {
      this.isAttributionGhostVisible = false;
    },
  },
};
</script>

<style scoped>
@reference '@/tailwind.css';

.attribute-wrapper::before {
  content: '';
  height: calc(100% + var(--tw-spacing) * 1);
  width: calc(100% + var(--tw-spacing) * 2);
  @apply tw:absolute tw:-left-1 tw:-top-0.5 tw:rounded-base tw:bg-white tw:-z-1;
}
</style>
